import clsx from 'clsx'

import { InputCounter, TextField } from './styles'
import type { CustomInputProps } from './types'

const CustomInput = ({
  name,
  placeholder,
  onChange,
  value,
  label,
  className,
  onBlur,
  maxSize = 0,
  currentSize = 0,
  disabled = false,
  hasError = false
}: CustomInputProps) => {
  return (
    <div className={clsx('hot-form', className)}>
      {label && (
        <label htmlFor={name} className='hot-form__label'>
          {label}
        </label>
      )}
      <div className='_position-relative'>
        {maxSize > 0 ? (
          <InputCounter
            className='_position-absolute _d-flex _flex-row _align-items-center _justify-content-start _mr-3 _text-1'
            data-test='input-value-counter'>
            <span>{currentSize}</span>
            <span>/</span>
            <span>{maxSize}</span>
          </InputCounter>
        ) : null}
        <TextField
          aria-label={placeholder}
          className='hot-form__input _bg-transparent _text-gray-700 _pr-8'
          type='text'
          name={name}
          placeholder={placeholder}
          onChange={onChange}
          value={value}
          disabled={disabled}
          autoComplete='off'
          hasError={hasError}
          onBlur={onBlur}
        />
      </div>
    </div>
  )
}

export default CustomInput
